module.exports = __webpack_public_path__ + "img/spotify_white.d82623fb.svg";